import React, { useEffect } from 'react'
import { Alert } from 'components'
import { Form } from 'components/Form'
import { gender } from 'keys'
import { useSelector } from 'react-redux'
import { useDispatch } from 'react-redux'
import { validate, validateIsAuth, createTicketHooks, uploadAudioHooks } from '.'
import { initialize, reset } from 'redux-form'
import { ContactUsAlertStyles } from './Style'
import { secretStorage } from 'config'

const CreateTicketAlert = (props) => {
    const { isUser } = props
    const { formname, getTitle } = createTicketHooks.constants

    const formValues = useSelector(state => state.form[formname]?.values)
    const dispatch = useDispatch()

    const { alerts } = useSelector(state => state.general)
    const { request_type } = formValues || {}

    const secretUser = secretStorage.getItem("user")
    const isMaleGender = secretUser?.gender === gender.male

    const setAlert = createTicketHooks.useAlert()
    const { formFields, isAuthFormFields } = createTicketHooks.useFormFields()
    const submitBtns = createTicketHooks.useSubmitBtns(isUser)

    useEffect(() => {
        return (() => {
            dispatch(reset(formname))
            dispatch(initialize(formname, {}));
        })
    }, [])

    const title = isUser ? getTitle(isMaleGender) : "נראה שנתקלת בבעיה להכנס למערכת. קצת פירוט יעזור לנו."

    return (
        <Alert
            systemUI
            title={request_type?.name || title}
            footerActions={submitBtns}
            handleAlert={() => setAlert(false)}
            closeOnClick
        >
            <ContactUsAlertStyles>
                <Form
                    form={formname}
                    validations={isUser ? validateIsAuth : validate}
                    fields={isUser ? isAuthFormFields : formFields}
                    submit={() => { }}
                />
            </ContactUsAlertStyles>
        </Alert>
    )
}

export default CreateTicketAlert